export { AtnDsRadioOptionComponent as Component } from './radio-option.component'
